export const STEP_SELECT_FNOL_CATEGORY = 'STEP_SELECT_FNOL_CATEGORY';
export const STEP_SELECT_FNOL_TEMPLATE = 'STEP_SELECT_FNOL_TEMPLATE';
export const STEP_ANSWER_QUESTIONS = 'STEP_ANSWER_QUESTIONS';
export const STEP_CONTACT_INFORMATION = 'STEP_CONTACT_INFORMATION';
export const STEP_CONTACT_PARTNER = 'STEP_CONTACT_PARTNER';
export const STEP_FNOL_RECIEVED = 'STEP_FNOL_RECIEVED';
export const STEP_IDENTIFY_CUSTOMER = 'STEP_IDENTIFY_CUSTOMER';
export const STEP_UPLOAD_FILE = 'STEP_UPLOAD_FILE;';
export const STEP_SEND_FNOL = 'STEP_SEND_FNOL';
